import React from 'react'
import { Box, useMediaQuery } from '@material-ui/core'
import resumePDF from '../../assets/pdf/Stanley_Chan_Resume.pdf'

const DownloadResumeButton = () => {
  const isMobile = useMediaQuery('(max-width: 768px)')

  return (
    <a
      href={resumePDF}
      download="Stanley_Chan_Resume.pdf"
      style={{ textDecoration: 'none' }}
    >
      <Box
        style={{
          padding: isMobile ? '0.75rem 1.5rem' : '1rem 2rem',
          background: 'linear-gradient(135deg, rgba(0, 255, 255, 0.1) 0%, rgba(255, 0, 255, 0.1) 100%)',
          border: '2px solid #00ffff',
          borderRadius: '8px',
          cursor: 'pointer',
          fontFamily: '"Orbitron", monospace',
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          fontWeight: 'bold',
          color: '#00ffff',
          textShadow: '0 0 10px #00ffff',
          transition: 'all 0.3s ease',
          backdropFilter: 'blur(10px)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)'
          e.currentTarget.style.boxShadow = '0 0 30px rgba(0, 255, 255, 0.6)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)'
          e.currentTarget.style.boxShadow = 'none'
        }}
      >
        {isMobile ? '📄 PDF' : '📄 DOWNLOAD RESUME PDF'}
      </Box>
    </a>
  )
}

export default DownloadResumeButton
